export default __webpack_public_path__ + "static/media/flag12.b9f472fd.jpg";